(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-care-guide"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-main-collection"]) return;
  try {
    
  const initializeCollectionDescriptions = (root = document) => {
    root.querySelectorAll('.main-collection__description').forEach((description) => {
      const seeMoreButton = description.querySelector('.main-collection__more');
      const contentBlocks = Array.from(description.children).filter((element) => element !== seeMoreButton);

      if (!seeMoreButton || contentBlocks.length <= 2) return;

      contentBlocks.slice(2).forEach((contentBlock) => {
        contentBlock.hidden = true;
      });

      seeMoreButton.hidden = false;
      seeMoreButton.addEventListener(
        'click',
        () => {
          contentBlocks.slice(2).forEach((contentBlock) => {
            contentBlock.hidden = false;
          });

          seeMoreButton.hidden = true;
          seeMoreButton.setAttribute('aria-expanded', 'true');
        },
        { once: true }
      );
    });
  };

  const url = new URL(window.location.href);

  document.addEventListener(
    'DOMContentLoaded',
    () => {
      initializeCollectionDescriptions();

      if (url.hash) {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      }
    },
    { once: true }
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-search-results"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
